export default __webpack_public_path__ + "static/and-logo-1-c4a594995c3be87b869b7d3773bc1224.webp";